

























































































































import { Vue, Component, Watch } from 'vue-property-decorator'

import * as jobs from '@/services/jobs'
import * as shifts from '@/services/shifts'
import { Managers, currentUserIs } from '@/types/Users'
import { Task } from '@/types/Jobs'
import { ClockEvent, ClockAction } from '@/types/Jobs'

import EditShiftDialog from '@/views/jobs/EditShiftDialog.vue'
import DeleteShiftDialog from '@/views/jobs/DeleteShiftDialog.vue'
import TaskList from '@/components/TaskList.vue'
import JobPreview from '@/components/JobPreview.vue'
import UserPreview from '@/components/UserPreview.vue'
import ClockButtons from '@/components/ClockButtons.vue'
import ClockEvents from '@/components/ClockEvents.vue'

// Return days, hours, minutes, and seconds between now and a given date
function timeBetween(time: Date) {
  const now = new Date()
  const diff = Math.abs(time.getTime() - now.getTime())
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  const hours = Math.floor(diff / (1000 * 60 * 60)) - (days * 24)
  const minutes = Math.floor(diff / (1000 * 60)) - (days * 24 * 60) - (hours * 60)
  const seconds = Math.floor(diff / 1000) - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60)

  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m ${seconds}s`
  } else if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`
  } else if (minutes > 0) {
    return `${minutes}m ${seconds}s`
  } else if (seconds > 0) {
    return `${seconds}s`
  } else {
    return 'now'
  }
}

@Component({
  components: {
    EditShiftDialog,
    DeleteShiftDialog,
    TaskList,
    JobPreview,
    UserPreview,
    ClockButtons,
    ClockEvents,
  },
})
export default class Shift extends Vue {
  
  loadingShift = false
  loadingJob = false

  editShiftDialog = false
  deleteShiftDialog = false

  timeUntilShift = ''
  timeSinceClockIn = ''

  async mounted() {
    const shift = await this.loadShift()

    console.log(shift)

    if (shift?.job_id) {
      this.loadJob(shift.job_id)
    }

    setInterval(() => {
      this.computeTimeUntilShift()
      this.computeTimeSinceClockIn()
    }, 1000)
  }

  @Watch('shift')
  onShiftChange() {
    this.computeTimeUntilShift()
  }

  @Watch('clockInTime')
  onClockInTimeChange() {
    this.computeTimeSinceClockIn()
  }

  metaInfo(): any {
    return {
      title: this.shift ? this.shift.site_location : 'Shift'
    }
  }

  // User info

  get me() {
    return this.$store.getters.me
  }

  get iAmVerified() {
    return this.$store.getters.iAmVerified
  }

  get userIsManager() {
    return currentUserIs(...Managers)
  }

  // Computed data

  get shift() {
    return this.$store.getters.shift(parseInt(this.$route.params.shiftId))
  }

  get contractor() {
    return this.$store.getters.user(this.shift.contractor_id)
  }

  get clock() {
    return this.$store.state.clock
  }

  get history() {
    if (!this.shift || !this.shift.clock_history) return []
    return this.shift.clock_history.sort((a: ClockEvent, b: ClockEvent) => {
      return (new Date(b.time)).getTime() - (new Date(a.time)).getTime()
    })
  }

  get job() {
    if (!this.shift) return null
    return this.$store.getters.job(this.shift.job_id)
  }

  get tasks() {
    return this.shift.tasks.sort((a: Task, b: Task) => a.id - b.id)
  }

  // Task info

  get totalTasks() {
    if (!this.shift?.tasks?.length) return 0
    return this.shift.tasks.length
  }

  get tasksComplete() {
    return this.shift.tasks.filter((task: Task) => task.complete).length
  }

  get allTasksComplete() {
    return this.tasksComplete == this.totalTasks
  }

  // Computed shift info

  get clockedIn() {
    if (!this.history.length) return false
    return this.history[0].action === ClockAction.ClockIn
  }

  get shiftIsActive() {
    if (!this.shift) return false
    const now = (new Date()).getTime()
    return (new Date(this.shift.time_begin)).getTime() <= now
      && (new Date(this.shift.time_end)).getTime() >= now
  }

  get shiftIsOver() {
    if (!this.shift) return false
    return (new Date(this.shift.time_end)).getTime() < (new Date()).getTime()
  }

  get isMyShift() {
    return this.me.id === this.shift.contractor_id
  }

  get clockInTime() {
    return this.history.find((e: ClockEvent) => e.action === ClockAction.ClockIn)?.time
  }

  computeTimeUntilShift() {
    if (!this.shift) return
    this.timeUntilShift = timeBetween(new Date(
      this.shiftIsActive ? this.shift.time_end : this.shift.time_begin
    ))
  }

  computeTimeSinceClockIn() {
    if (!this.clockInTime) return
    this.timeSinceClockIn = timeBetween(new Date(this.clockInTime))
  }

  // Network actions

  async loadShift() {
    this.loadingShift = true
    try {
      return shifts.loadShift(this.$store, parseInt(this.$route.params.shiftId))
    }
    finally {
      this.loadingShift = false
    }
  }

  async loadJob(jobId: number) {
    this.loadingJob = true
    if (!this.shift || !this.shift.job_id) return
    try {
      await jobs.loadJob(this.$store, jobId)
    }
    finally {
      this.loadingJob = false
    }
  }
}
